<template>
    <section id="registerDiv">
        <div class="container mt-5">
            <!-- Jumbotron -->
            <div class="px-4 py-5 px-md-5 text-center text-lg-start loginContain">
                <div class="container">
                    <div class="row gx-lg-5 align-items-center">
                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <img class="pt-7 pt-md-0 hero-img" src="../../assets/img/reg.png">
                            <h1 class="my-5 display-3 fw-bold ls-tight">
                                The best offer <br />
                                <span class="text-primary">for your business</span>
                            </h1>
                            <p style="color: hsl(217, 10%, 50.8%)">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Eveniet, itaque accusantium odio, soluta, corrupti aliquam
                                quibusdam tempora at cupiditate quis eum maiores libero
                                veritatis? Dicta facilis sint aliquid ipsum atque?
                            </p>
                        </div>

                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <div class="card" style="background-color: #f8f8f8;">
                                <div class="card-body py-5 px-md-5" id="loginBox">
                                    <div class="row">
                                        <div class="col-12" id="box">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label for="fName" class="control-label"></label>
                                                    <input type="text" class="col-12 inputText form-control borderR"
                                                        placeholder="First Name *" id="fName" name="fName" required />
                                                    <small class="text-danger" id="fNameError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="lName" class="control-label"></label>
                                                    <input type="text" class="col-12 inputText form-control borderR"
                                                        placeholder="Last Name *" id="lName" name="lName" required />
                                                    <small class="text-danger" id="lNameError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="email" class="control-label"></label>
                                                    <input type="email" class="col-12 inputText form-control borderR"
                                                        placeholder="Email *" id="email" name="email" required />
                                                    <small class="text-danger" id="emailError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="mainCountry" class="control-label"></label>
                                                    <select class="inputText form-control borderR" id="mainCountry"
                                                        name="mainCountry" required>
                                                        <option value="">- Select Country -</option>
                                                    </select>
                                                    <small class="text-danger" id="mainCountryError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="password" class="control-label"></label>
                                                    <input type="password" class="col-12 inputText form-control borderR"
                                                        placeholder="Password" id="password" name="password" required
                                                        data-bs-toggle="tooltip" data-bs-placement="right"
                                                        title="Password should be at least 8 characters long, contain uppercase and lowercase letters, numbers, and special characters." />
                                                    <div class="progress mt-2">
                                                        <div id="passwordStrengthBar" class="progress-bar"
                                                            role="progressbar" style="width: 0%;" aria-valuenow="0"
                                                            aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                    <small id="passwordStrength" class="text-muted"></small>
                                                    <small class="text-danger" id="passwordError"></small>
                                                </div>


                                            </div>
                                            <div class="row mt-3">
                                                <div class="col-md-12">
                                                    <input type="checkbox" id="cbGuide">
                                                    <label for="" class="control-label" style="padding-left: 10px;"> Are
                                                        you a tour
                                                        organizer</label>
                                                </div>

                                                <input type="hidden" id="accType" name="accType" value="Tourist"
                                                    required />
                                            </div>
                                            <button type="button" class="col-12 btn btn-info mt-4" id="saveRegBtn">
                                                Register
                                            </button>
                                        </div>
                                        <div class="alert alert-success" role="alert" id="successMsg">
                                            <h4 class="alert-heading">Well done!</h4>
                                            <p>Aww yeah! Your account has been successfully registered. Check your email for the verification link—after verifying your email, you can access your account.</p>
                                            <hr>
                                            <p class="mb-0">Thank you for choosing US!</p>
                                        </div>
                                       
                                        <button type="button" class="col-4 btn btn-info" id="successBtn">
                                            Goto Home
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Section: Design Block -->
            </div>
        </div>
    </section>
</template>

<script>
import $ from 'jquery';
import { Tooltip } from 'bootstrap';

export default {
    name: 'RegiPage',
    mounted() {
        $('#successMsg').hide();
        this.fetchOptionsCity();
        this.initializeEventListeners();   // Fetch data when component is mounted
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new Tooltip(tooltipTriggerEl);
        });
    },
    methods: {
        async fetchOptionsCity() {
            console.log("working...1");
            try {
                $.ajax({
                    url: process.env.VUE_APP_API_URL + "/fetchCountry",
                    method: "GET",
                    success: (data) => {
                        console.log(data);
                        if (data && Array.isArray(data)) {
                            // Populate dropdown options
                            const $dropdown = $("#mainCountry");
                            $dropdown.empty(); // Clear existing options
                            $dropdown.append(
                                $("<option>", {
                                    value: '',
                                    text: "Country *",
                                })
                            );
                            // Append new options
                            data.forEach((country) => {
                                $dropdown.append(
                                    $("<option>", {
                                        value: country.id,  // Assuming 'id' is the unique identifier for country
                                        text: country.name, // Assuming 'name' is the country name
                                    })
                                );
                            });
                        } else {
                            console.error("Unexpected data structure", data);
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        console.error("Error fetching options:", textStatus, errorThrown);
                    },
                });
            } catch (error) {
                console.error("Error fetching options:", error);
            }
        },
        saveCustomer() {
            var fName = $('#fName').val();
            var lName = $('#lName').val();
            var email = $('#email').val();
            var password = $('#password').val();
            // var passwordConfirmation = $('#cPassword').val(); // Ensure you have a matching field for password confirmation
            var country = $('#mainCountry').val();
            var accType = $('#accType').val();

            // Log data for debugging
            console.log(fName, lName, email, password, country);

            $.ajax({
                url: process.env.VUE_APP_API_URL + '/saveCustomer',
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') // Add CSRF token
                },
                data: {
                    fName: fName,
                    lName: lName,
                    email: email,
                    password: password,
                    // password_confirmation: passwordConfirmation, // Send password confirmation
                    country: country,
                    accType: accType
                },
                beforeSend: function () {
                    // Show the loading screen before sending the request
                    $('#loadingScreen').removeClass('d-none');
                },

                success: function (response) {
                    // Handle success response
                    console.log(response);
                    // Hide the loading screen
                    $('#loadingScreen').addClass('d-none');
                    //alert('Data saved successfully!');
                    $('#box').hide();
                    $('#saveRegBtn').hide();
                    $('#successMsg').show();
                    $('#successBtn').show();

                },
                error: function (xhr, status, error) {
                    $('#loadingScreen').addClass('d-none');

                    console.log(status, error);
                    // Handle error response
                    if (xhr.status === 422) {
                        // Extract validation errors
                        var errors = xhr.responseJSON.errors;
                        var errorMessages = '';

                        // Concatenate error messages
                        $.each(errors, function (key, messages) {
                            errorMessages += messages.join('\n') + '\n';
                        });

                        // Display error messages
                        //alert('Validation errors:\n' + errorMessages);
                        $('#emailError').text(errorMessages + '.');
                    } else {
                        // Fallback to general error message
                        var errorMessage = 'An error occurred. Please try again.';
                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            errorMessage = xhr.responseJSON.message;
                        } else if (xhr.responseText) {
                            errorMessage = xhr.responseText;
                        }
                        alert(errorMessage);

                    }
                }
            });
        },
        initializeEventListeners() {
            // Function to remove highlight from all buttons
            function removeHighlight() {
                $('.btn-light').removeClass('active'); // Adjust class if necessary

                $('#accType').val('');
            }

            $('#successBtn').click(function () {
                window.location.href = '/';
            });

            // Add click event for Tourist button
            $(document).on('click', '#touristButton', function () {
                console.log('Tourist button clicked');

                removeHighlight(); // Remove highlight from all buttons
                $(this).addClass('active'); // Highlight the clicked button
                // Handle Tourist button click
                $('#accType').val('Tourist');
            });


            // Add click event for Guide button
            $(document).on('click', '#guideButton', function () {

                // $('#guideButton').click(function () {
                removeHighlight(); // Remove highlight from all buttons
                $(this).addClass('active'); // Highlight the clicked button
                // Handle Guide button click
                console.log('Guide button clicked');
                $('#accType').val('Guide');
            });


            // Password strength meter on typing
            $('#password').on('input', function () {
                $('#box small.text-danger').text('');
                const password = $(this).val();
                //const strengthIndicator = $('#passwordStrength');
                const strengthBar = $('#passwordStrengthBar');
                let strength = 0;

                // Calculate password strength
                if (password.length >= 8) strength += 20;
                if (/[A-Z]/.test(password)) strength += 30;
                if (/[a-z]/.test(password)) strength += 30;
                if (/[0-9]/.test(password)) strength += 10;
                if (/[\W]/.test(password)) strength += 10;

                // Update progress bar
                strengthBar.css('width', strength + '%');
                strengthBar.attr('aria-valuenow', strength);

                if (strength < 50) {
                    strengthBar.removeClass('bg-success bg-warning').addClass('bg-danger');
                    // strengthIndicator.text('Password is too weak.').removeClass('text-success text-warning').addClass('text-danger');
                } else if (strength < 75) {
                    strengthBar.removeClass('bg-success bg-danger').addClass('bg-warning');
                    // strengthIndicator.text('Password strength is moderate.').removeClass('text-success text-danger').addClass('text-warning');
                } else {
                    strengthBar.removeClass('bg-warning bg-danger').addClass('bg-success');
                    // strengthIndicator.text('Password strength is good.').removeClass('text-danger text-warning').addClass('text-success');
                }

                // Trigger confirm password check on password input change
                // $('#cPassword').trigger('input');
            });

            // Confirm password matching on typing
            // $('#cPassword').on('input', function () {
            //     const password = $('#password').val();
            //     const confirmPassword = $(this).val();
            //     const confirmPasswordError = $('#cPasswordError');
            //     const confirmPasswordBar = $('#confirmPasswordBar');
            //     let matchStrength = 0;

            //     // Calculate how much the passwords match
            //     if (confirmPassword.length > 0 && confirmPassword === password) {
            //         matchStrength = 100;
            //     } else if (confirmPassword.length > 0 && password.startsWith(confirmPassword)) {
            //         matchStrength = (confirmPassword.length / password.length) * 100;
            //     }

            //     // Update progress bar for confirm password
            //     confirmPasswordBar.css('width', matchStrength + '%');
            //     confirmPasswordBar.attr('aria-valuenow', matchStrength);

            //     if (matchStrength === 100) {
            //         confirmPasswordBar.removeClass('bg-danger').addClass('bg-success');
            //         confirmPasswordError.text('Passwords match.').addClass('text-success').removeClass('text-danger');
            //     } else {
            //         confirmPasswordBar.removeClass('bg-success').addClass('bg-danger');
            //         confirmPasswordError.text('Passwords do not match.').addClass('text-danger').removeClass('text-success');
            //     }
            // });

            $('#cbGuide').change(function () {
                if ($(this).is(':checked')) {
                    $('#accType').val('Organizer');
                } else {
                    $('#accType').val('Tourist');
                }
            });

            const self = this;
            $('#saveRegBtn').click(function () {

                let valid = true;

                // Clear previous error messages
                $('#box small.text-danger').text('');

                // Validate each input and select field
                $('#registerDiv input, #registerDiv select').each(function () {
                    const id = $(this).attr('id');
                    const fieldLabel = $(this).attr('placeholder') || $(this).find('option:selected').text();

                    if ($(this).val() === '') {
                        valid = false;
                        $(`#${id}Error`).text(`${fieldLabel.replace(' *', '')} is required.`);
                    }
                });

                // Email validation
                const email = $('#email').val();
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (email && !emailPattern.test(email)) {
                    valid = false;
                    $('#emailError').text('Please enter a valid email address.');
                }

                // Password strength validation
                const password = $('#password').val();
                let strength = 0;

                // Calculate password strength
                if (password.length >= 8) strength += 20;
                if (/[A-Z]/.test(password)) strength += 30;
                if (/[a-z]/.test(password)) strength += 30;
                if (/[0-9]/.test(password)) strength += 10;
                if (/[\W]/.test(password)) strength += 10;

                if (strength < 100) {
                    valid = false;
                    $('#passwordError').text('Password strength must be 100%.');
                }

                if (!valid) {
                    return; // Stop if any validation fails
                } else {
                    self.saveCustomer();
                }

            });

        }
    }
}
</script>

<style scoped>
#successMsg {
    display: none;
    /* Initially hide successMsg */
}

#successBtn {
    display: none;
    /* Initially hide successBtn */
}
</style>
